import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
import { Lock, Shield, CreditCard, AccessTime } from '@mui/icons-material';
export function PricingSection() {
  const [selectedPlan, setSelectedPlan] = useState<'standard' | 'premium'>('premium');
  return <section className="py-16 px-4 bg-miel-darker relative overflow-hidden" id="pricing" data-id="element-209">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-miel-crimson/10 rounded-full blur-[100px] pointer-events-none" data-id="element-210" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-211">
        {/* Urgency Header */}
        <FadeIn data-id="element-212">
          <div className="text-center mb-10" data-id="element-213">
            <h2 className="text-miel-gold tracking-widest uppercase text-sm font-bold mb-6 flex items-center justify-center gap-2" data-id="element-214">
              <span data-id="element-215">⏰</span> PRECIO DE LANZAMIENTO — CIERRA EN:
            </h2>

            <div className="mb-8" data-id="element-216">
              <CountdownTimer data-id="element-217" />
            </div>

            <div className="inline-block bg-miel-red/20 border border-miel-red/50 text-miel-cream px-6 py-3 rounded-lg mb-8" data-id="element-218">
              <span className="text-xl" data-id="element-219">⚠️</span> Después sube $10.000 ARS. No
              vuelve.
            </div>

            <div className="max-w-md mx-auto" data-id="element-220">
              <div className="flex justify-between text-sm mb-2" data-id="element-221">
                <span className="text-miel-crimson font-bold flex items-center gap-1" data-id="element-222">
                  <span className="w-2 h-2 rounded-full bg-miel-crimson animate-pulse" data-id="element-223"></span>
                  Cupos al precio de lanzamiento
                </span>
                <span className="text-miel-cream/60" data-id="element-224">Quedan pocos</span>
              </div>
              <div className="h-3 bg-miel-dark rounded-full overflow-hidden border border-miel-crimson/20" data-id="element-225">
                <div className="h-full bg-gradient-to-r from-miel-crimson to-miel-red w-[68%] rounded-full relative" data-id="element-226">
                  <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/diagonal-stripes.png')] opacity-20" data-id="element-227"></div>
                </div>
              </div>
              <p className="text-xs text-miel-cream/50 mt-2 text-right" data-id="element-228">
                68% de los cupos ya tomados
              </p>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-229">
          <h3 className="text-center font-playfair text-3xl md:text-4xl text-miel-cream mb-12" data-id="element-230">
            ELEGÍ TU MIEL ROJA™
          </h3>
        </FadeIn>

        {/* Pricing Cards */}
        <div className="flex flex-col gap-4 max-w-2xl mx-auto" data-id="element-231">
          {/* Card 1: Standard */}
          <FadeIn delay={0.3} direction="up" data-id="element-232">
            <div onClick={() => setSelectedPlan('standard')} className={`bg-miel-dark rounded-2xl p-5 sm:p-6 cursor-pointer transition-all flex items-start gap-4 relative overflow-hidden ${selectedPlan === 'standard' ? 'border-2 border-miel-gold shadow-[0_0_20px_rgba(212,175,55,0.15)]' : 'border border-miel-crimson/30 hover:border-miel-crimson/60'}`} data-id="element-233">
              {/* Radio */}
              <div className="mt-1 flex-shrink-0" data-id="element-234">
                <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'standard' ? 'border-miel-gold' : 'border-miel-cream/30'}`} data-id="element-235">
                  <div className={`w-3 h-3 rounded-full bg-miel-gold transition-opacity ${selectedPlan === 'standard' ? 'opacity-100' : 'opacity-0'}`} data-id="element-236" />
                </div>
              </div>

              {/* Content */}
              <div className="flex-grow flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 w-full" data-id="element-237">
                <div className="flex-grow" data-id="element-238">
                  <div className="text-xl mb-1" data-id="element-239">⚡</div>
                  <h4 className="font-playfair font-bold text-miel-cream text-base sm:text-lg leading-tight uppercase" data-id="element-240">
                    MIEL ROJA™ — EL PROTOCOLO DEL RETORNO
                  </h4>
                  <p className="text-miel-cream/70 text-sm mt-1" data-id="element-241">
                    Pack completo + 5 bonos
                  </p>
                </div>
                <div className="text-left sm:text-right flex flex-col items-start sm:items-end flex-shrink-0" data-id="element-242">
                  <span className="text-miel-cream/40 line-through text-sm sm:text-base" data-id="element-243">
                    $62.000
                  </span>
                  <span className="text-miel-gold font-bold text-3xl sm:text-4xl font-playfair leading-none mt-1" data-id="element-244">
                    $19.999
                  </span>
                </div>
              </div>
            </div>
          </FadeIn>

          {/* Card 2: Premium */}
          <FadeIn delay={0.4} direction="up" data-id="element-245">
            <div onClick={() => setSelectedPlan('premium')} className={`bg-gradient-to-b from-miel-dark to-miel-darker rounded-2xl p-5 sm:p-6 cursor-pointer transition-all flex items-start gap-4 relative overflow-hidden ${selectedPlan === 'premium' ? 'border-2 border-miel-gold shadow-[0_0_30px_rgba(212,175,55,0.2)]' : 'border border-miel-crimson/30 hover:border-miel-crimson/60'}`} data-id="element-246">
              {/* Radio */}
              <div className="mt-1 flex-shrink-0" data-id="element-247">
                <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'premium' ? 'border-miel-gold' : 'border-miel-cream/30'}`} data-id="element-248">
                  <div className={`w-3 h-3 rounded-full bg-miel-gold transition-opacity ${selectedPlan === 'premium' ? 'opacity-100' : 'opacity-0'}`} data-id="element-249" />
                </div>
              </div>

              {/* Content */}
              <div className="flex-grow flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 w-full" data-id="element-250">
                <div className="flex-grow" data-id="element-251">
                  <div className="text-xl mb-1" data-id="element-252">🏆</div>
                  <h4 className="font-playfair font-bold text-miel-cream text-base sm:text-lg leading-tight uppercase" data-id="element-253">
                    MIEL ROJA™ + SELLO DE ORO
                  </h4>
                  <div className="flex flex-wrap gap-2 mt-2 mb-2" data-id="element-254">
                    <span className="bg-miel-gold text-miel-darkest text-[10px] sm:text-xs font-bold px-2 py-0.5 rounded flex items-center gap-1" data-id="element-255">
                      ⭐ MÁS ELEGIDO
                    </span>
                    <span className="border border-miel-gold text-miel-gold text-[10px] sm:text-xs font-bold px-2 py-0.5 rounded" data-id="element-256">
                      AHORRÁS $79.001
                    </span>
                  </div>
                  <p className="text-miel-cream/70 text-sm" data-id="element-257">
                    Todo lo anterior + Sello de Oro blindaje completo
                  </p>
                </div>
                <div className="text-left sm:text-right flex flex-col items-start sm:items-end flex-shrink-0" data-id="element-258">
                  <span className="text-miel-cream/40 line-through text-sm sm:text-base" data-id="element-259">
                    $109.000
                  </span>
                  <span className="text-miel-gold font-bold text-3xl sm:text-4xl font-playfair leading-none mt-1" data-id="element-260">
                    $29.999
                  </span>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>

        {/* Below Cards CTA */}
        <FadeIn delay={0.5} direction="up" data-id="element-261">
          <div className="max-w-2xl mx-auto mt-8 text-center" data-id="element-262">
            <CtaButton href={selectedPlan === 'standard' ? 'https://pagos.indigo33.shop/cart/43973449154648:1' : 'https://pagos.indigo33.shop/cart/43973583503448:1'} fullWidth className="text-lg py-4 mb-4 shadow-[0_0_20px_rgba(212,175,55,0.3)]" data-id="element-263">
              SÍ, QUIERO MI MIEL ROJA
            </CtaButton>

            <p className="text-miel-cream/70 italic text-sm mb-8 px-4" data-id="element-264">
              La opción más elegida por mujeres que quieren recuperar su amor de
              verdad
            </p>

            <div className="flex flex-col items-center gap-4 text-sm text-miel-cream/80" data-id="element-265">
              <div className="flex flex-wrap justify-center items-center gap-6" data-id="element-266">
                <span className="flex items-center gap-1.5" data-id="element-267">
                  <Lock fontSize="small" className="text-miel-gold" data-id="element-268" /> Pago
                  seguro
                </span>
                <span className="flex items-center gap-1.5" data-id="element-269">
                  <AccessTime fontSize="small" className="text-miel-gold" data-id="element-270" />{' '}
                  Acceso en 5 min
                </span>
              </div>
              <div className="flex flex-wrap justify-center items-center gap-3" data-id="element-271">
                <span className="flex items-center gap-1.5" data-id="element-272">
                  <Shield fontSize="small" className="text-miel-gold" data-id="element-273" />{' '}
                  Garantía 7 días
                </span>
                <span className="text-miel-cream/30 hidden sm:inline" data-id="element-274">•</span>
                <span className="flex items-center gap-1.5" data-id="element-275">
                  <CreditCard fontSize="small" className="text-miel-gold" data-id="element-276" />{' '}
                  Mercado Pago
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}